import { PropsWithChildren } from 'react';
import CloseFillIcon from 'remixicon-react/CloseFillIcon';
import { PopupModalTheme } from '..';
import useWindowWidth from '../../useWindowWidth';

const MainContent = ({
  title,
  description,
  titleColor,
  allowClose,
  theme,
  onClose,
  titleSize,
  children,
}: PropsWithChildren<{
  title?: string;
  description?: string;
  titleColor?: string;
  theme?: PopupModalTheme;
  allowClose?: boolean;
  titleSize: 'md' | 'lg';
  onClose?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}>) => {
  const { isLg } = useWindowWidth();
  return (
    <div
      className={` flex h-full
        flex-col bg-white px-3 pb-10 pt-7 lg:px-7 `}
    >
      <div className="flex items-start justify-between gap-x-6 ">
        <div
          className={`flex-1 text-left font-bold text-${titleColor} ${
            titleSize === 'md' ? 'lg:text-title-6' : 'lg:text-title-4'
          }`}
        >
          {title}
        </div>
        {allowClose !== false && (
          <div className={`cursor-pointer text-${theme}`} onClick={onClose}>
            <CloseFillIcon />
          </div>
        )}
      </div>
      {description && <div className={`text-grey-700 pt-4 ${!isLg && 'text-body-3'}`}>{description}</div>}
      <div className="mt-4 h-full">{children}</div>
    </div>
  );
};

export default MainContent;
